import Dialog from "src/components/Dialog/index";
import { useTranslation } from "react-i18next";

export default function NoPairedDevices({ onClose, onContinue, isOpen }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      type="warning"
      heading={t("noPairedDevices")}
      text={t("pairWithDeviceFirst")}
      buttons={[
        {
          onClick: onClose,
          text: t("buttons.cancel")
        },
        {
          onClick: onContinue,
          text: t("buttons.pairNewDevice")
        }
      ]}
    />
  );
}
